// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ClaimValueOfRepair from '@deere/cps-it.warranty-model-factory/lib/claim-value-of-repair';
import {FormattedMessage} from 'react-intl';
import ValueOfRepairRow from './row';

const ValueOfRepairPanel = props =>
    <section className='value-of-repair'>
        <header>
            <FormattedMessage id='VALUE_OF_REPAIR'/>
        </header>
        <section className='value-of-repair-headers'>
            <section className='net'>
                <FormattedMessage id='NET'/>
            </section>
            <section className='list'>
                <FormattedMessage id='LIST'/>
            </section>
        </section>
        <ValueOfRepairRow
            label='PART_VALUE'
            listValue={props.listPricing.partValues}
            netValue={props.netPricing.partValues}
        />
        <ValueOfRepairRow
            label='ON_SHELF_COST'
            listValue={props.listPricing.onShelfCost}
            netValue={props.netPricing.onShelfCost}
        />
        <ValueOfRepairRow
            label='CORE_VALUE'
            listValue={props.listPricing.coreValues}
            netValue={props.netPricing.coreValues}
        />
        <ValueOfRepairRow
            isTotal={true}
            label='PART_TOTAL'
            listValue={props.listPricing.partsTotal}
            netValue={props.netPricing.partsTotal}
        />
        <ValueOfRepairRow
            label='LABOR_VALUE'
            listValue={props.listPricing.laborValue}
            netValue={props.netPricing.laborValue}
        />
        <ValueOfRepairRow
            isTotal={true}
            label='LABOR_TOTAL'
            listValue={props.listPricing.laborTotal}
            netValue={props.netPricing.laborTotal}
        />
        <ValueOfRepairRow
            label='TRAVEL'
            listValue={props.listPricing.travel}
            netValue={props.netPricing.travel}
        />
        <ValueOfRepairRow
            isTotal={true}
            label='OTHER_CREDIT_TOTAL'
            listValue={props.listPricing.otherCreditTotal}
            netValue={props.netPricing.otherCreditTotal}
        />
        <ValueOfRepairRow
            isTotal={true}
            label='TOTAL_AMOUNT'
            listValue={props.listPricing.totalAmount}
            netValue={props.netPricing.totalAmount}
        />
    </section>;

ValueOfRepairPanel.displayName = 'ValueOfRepairPanel';
ValueOfRepairPanel.propTypes = {
    listPricing: PropTypes.instanceOf(ClaimValueOfRepair).isRequired,
    netPricing: PropTypes.instanceOf(ClaimValueOfRepair).isRequired
};

export default ValueOfRepairPanel;



// WEBPACK FOOTER //
// ./src/claim/spa/components/value-of-repair/index.js